import React, { useEffect, useRef, useState } from "react";
import styles from "./customerOrderDetails.module.scss";
import { Add } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import { Button, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { connect, useDispatch } from "react-redux";
import {
  getAllOrders,
  getOrdersByCustomerId,
  getPendingOrdersResponse,
  getProductById,
} from "../../store/actions";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "Order ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "Cart Bundle ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "customer Id",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "Status",
    minWidth: 170,
    align: "center",
  },
];

const CustomerOrderDetails = ({ orders = [], customer = {} }) => {
  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const [searched, setsearched] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    dispatch(getOrdersByCustomerId({ id: customer?.id }));
  }, []);

  const handleStatusFilter = () => {
    const filterData = orders?.filter((item) => item?.status !== -1);
    return filterData;
  };

  const handleBtn = (status) => {
    switch (status) {
      case 0:
        return (
          <Button
            variant="contained"
            className={styles.ovalButton0}
            disableRipple
            disableElevation
          >
            Placed
          </Button>
        );
      case 1:
        return (
          <Button
            variant="contained"
            className={styles.ovalButton1}
            disableRipple
            disableElevation
          >
            Packed
          </Button>
        );
      case 2:
        return (
          <Button
            variant="contained"
            className={styles.ovalButton2}
            disableRipple
            disableElevation
          >
            Shiped
          </Button>
        );
      case 3:
        return (
          <Button
            variant="contained"
            className={styles.ovalButton3}
            disableRipple
            disableElevation
          >
            Delivered
          </Button>
        );
      default:
        return (
          <Button
            variant="contained"
            className={styles.ovalButton4}
            disableRipple
            disableElevation
          >
            Cancelled
          </Button>
        );
    }
  };

  const handleNavigate = (item = {}) => {
    dispatch(getPendingOrdersResponse(item));
    dispatch(getProductById({ id: item?.productId }));
    navigate("/orderdetails");
  };

  const getStructuredRows = (data = []) => {
    const structuredRows = data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          disableElevation
          onClick={() => handleNavigate(item)}
        >
          {item?.orderCode || "NA"}
        </Button>,
        item?.cartBundleId,
        item?.customerId,
        handleBtn(item?.status),
      ],
    }));

    return structuredRows;
  };
  const getData = (input, data) => {
    const dataFilter = data?.filter((item) =>
      item?.name?.toLowerCase().includes(input?.toLowerCase())
    );
    if (dataFilter?.length > 0) {
      setFilteredData(dataFilter);
    } else {
      setFilteredData(null);
    }
  };

  const handleSearch = (value) => {
    setsearched(value);
    console.log("ssss", value);
    if (value.length === 0) {
      setFilteredData([]);
    } else {
      // return getData(value, brand);
    }
  };

  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="CUSTOMER ORDERS" // or any icon/component
      />
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          {/* <div className={styles.search}>
            <SearchInput />
            <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
            >
              Filter
            </Button>
          </div> */}
        </div>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(handleStatusFilter(orders))}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    orders: state?.orders?.orders,
    customer: state?.customer?.customer,
  };
};

export default connect(mapStateToProps, null)(CustomerOrderDetails);
